import {html} from 'lit-html';
import templateProject from './template-project';

const { __ } = wp.i18n;

const template = (data) => html`
<div class="project-offer-result-wrapper">
	<div class="project-offer-result-container content">
		${(data => {
		if (data.state.projectsDisplayed.length > 0) {
			return html`
				<h2 class="project-offer-project-name">${data.props.title ? html`${data.props.title}` : html`${__('Offer', 'real-estate-project')}`}</h2>
				<ul class="project-offer-project-items-container">
					${data.state.projectsDisplayed.map((project) => html`<li class="project-offer-project-item-container">${templateProject(data.state.showAvailablePropertiesCount, project)}</li>`)}
				</ul>
				`;
		}
		else if(data.state.projectDataLoaded) {
			return html`<p class="project-offer-result-container-no-projectes-found">${__('No projects found', 'real-estate-project')}</p>`;
		}
	})(data)}
		${data.state.errorMessages ? html`${data.state.errorMessages.map(errorMessage => html`<p class="project-offer-result-container-message-error message message-error">${errorMessage}</p>`)}` : ''}
	</div>
</div>
`;

export default template;